import {FC} from 'react'

type Props = {
  content?: string
  className?: string
  title?: string
}

const TextCell: FC<Props> = ({content, className, title}) => (
  <div className={className} title={title}>{content}</div>
)

export {TextCell}
